import { API_BASE_URL } from '../config/api';

/**
 * Normalizes document URLs for consistent access.
 * - Absolute URLs (http/https) are returned as-is
 * - Blob URLs (blob:) are returned as-is (newly uploaded files)
 * - Data URLs (data:) are returned as-is
 * - Relative URLs are prepended with API_BASE_URL (legacy uploaded files)
 */
export function normalizeDocumentUrl(url: string | undefined): string {
  if (!url) return '';
  
  // Already absolute or special URL scheme
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('blob:') ||
    url.startsWith('data:')
  ) {
    return url;
  }
  
  // Relative URL - prepend API base
  return `${API_BASE_URL}${url}`;
}
